var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "查看附件",
        visible: _vm.dialogVisible,
        width: "860px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "header" }, [
          _c(
            "div",
            [
              _c("span", { staticClass: "label" }, [_vm._v("附件类型")]),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.uploadType,
                    callback: function ($$v) {
                      _vm.uploadType = $$v
                    },
                    expression: "uploadType",
                  },
                },
                _vm._l(_vm.fileTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "upload-file" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("上传文件")]),
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: "/api/Importer/uploadImporterFile",
                    headers: _vm.headers,
                    "show-file-list": false,
                    data: {
                      importerId: _vm.rowData.id,
                      uploadType: _vm.uploadType,
                    },
                    "before-upload": _vm.beforeUpload,
                    "on-success": _vm.onSuccess,
                    "on-error": _vm.onError,
                  },
                },
                [
                  _c("div", { staticClass: "upload-btn" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/bill/upload.png"),
                        width: "20",
                        height: "20",
                      },
                    }),
                    _vm._v("点击上传 或 拖拽文件上传 "),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "data" },
          [
            _c("BaseTable", {
              attrs: { height: 300, tableData: _vm.tableData, isPager: false },
              scopedSlots: _vm._u([
                {
                  key: "opt",
                  fn: function (row) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.optFile(row.scope, 0)
                            },
                          },
                        },
                        [_vm._v("查看")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.optFile(row.scope, 1)
                            },
                          },
                        },
                        [_vm._v("下载")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }